import { System } from '@ecs/System';
import { ExplosionRequest } from '@components/ExplosionRequest';
import { ShieldImpactRequest } from '@components/ShieldImpactRequest';
import { SoundManager, SoundType } from '@audio/SoundManager';
import { Effects } from '@/effects/Effects';

export class CollisionEffectSystem extends System {
  private soundManager = SoundManager.getInstance();

  update(_deltaTime: number): void {
    // Process explosion requests
    const explosionRequests = this.getEntitiesWithComponents(ExplosionRequest);
    for (const entity of explosionRequests) {
      const request = entity.getComponent(ExplosionRequest)!;

      if (request.particleCount >= 8) {
        Effects.explosion(this.world, request.x, request.y, {
          count: request.particleCount,
          color: request.particleColor,
          secondaryColor: request.secondaryColor,
          speed: request.particleSpeed,
          size: request.particleSize,
        });
      } else {
        // Non-lethal hull hit: a small spark burst
        Effects.sparks(this.world, request.x, request.y, 0, Math.PI * 2, request.particleColor, request.particleCount + 2, 3);
        Effects.sparks(this.world, request.x, request.y, 0, Math.PI * 2, request.secondaryColor, 2, 2);
      }
      
      // Play appropriate sound based on particle count (size)
      if (request.particleCount >= 30) {
        this.soundManager.playSound(SoundType.EXPLOSION_LARGE, 0.9);
      } else if (request.particleCount >= 20) {
        this.soundManager.playSound(SoundType.EXPLOSION_SMALL, 0.7);
      } else {
        this.soundManager.playSound(SoundType.HULL_IMPACT_LIGHT, 0.6);
      }
      
      // Remove the request component
      entity.removeComponent(ExplosionRequest);
    }

    // Process shield impact requests
    const shieldRequests = this.getEntitiesWithComponents(ShieldImpactRequest);
    for (const entity of shieldRequests) {
      const request = entity.getComponent(ShieldImpactRequest)!;
      Effects.shieldRipple(this.world, request.x, request.y, request.angle, request.particleColor);
      
      // Play shield impact sound
      this.soundManager.playSound(SoundType.SHIELD_IMPACT_LIGHT, 0.7);
      
      // Remove the request component
      entity.removeComponent(ShieldImpactRequest);
    }
  }
}
